/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "../../../utils/routes";
import Axios from "axios";
import { getAll } from "../../../utils/requests/dynamicReq";
import { paths } from "../../../utils/paths";

//search feature
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import Col from "react-bootstrap/esm/Col";
import Form from "react-bootstrap/esm/Form";
import InputGroup from "react-bootstrap/esm/InputGroup";
import { searchInvestigators } from "../../../utils/auxiliar/investigators";
import { IInvestShort } from "../../../interfaces/IInvestigatorShort";
import * as XLSX from "xlsx";

export const Users: FC = () => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);

  const isMountedRef = useRef(false);
  const source = Axios.CancelToken.source();
  const { INVESTIGATORS } = paths;
  const [investigators, setInvestigators] = useState<any>([]);
  const [search, setSearch] = useState("");
  const [filteredInvestigators, setFilteredInvestigators] = useState<
    any[]
  >([]);

  useEffect(() => {
    setIsLoading(true);
    isMountedRef.current = true;
    loadInvestigators();
    return () => {
      isMountedRef.current = false;
      source.cancel();
    };
  }, []);

  const loadInvestigators = async () => {
    try {
      const response = await getAll(INVESTIGATORS, source);
      if (isMountedRef.current) {
        filterInvestigators(response);
      }
      setIsLoading(false);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

 const filterInvestigators = (rawInvestigators: any[]) => {
   // En lugar de mapear solo algunos campos, guardo el objeto entero
   const investigators: IInvestShort[] = rawInvestigators.map(
     (investigator) => ({
       ...investigator,
       id: investigator.id,
       nombre: investigator.nombre,
       apellidos: investigator.apellidos,
     })
   );

   sortBySurname1(investigators);
 };

  const sortBySurname1 = (users:IInvestShort[]) => {
    users.sort((a, b) => a.apellidos.localeCompare(b.apellidos));
    setInvestigators(users);
    setFilteredInvestigators(users);
   
  };

  const handleSearch = (value: any) => {
    setSearch(value);
    setFilteredInvestigators(searchInvestigators(investigators, value));
    !value && setFilteredInvestigators(investigators);
  };

const handleExportToExcel = () => {
  if (!investigators) return;

  const dataToExport = investigators.map((investigator: any) => ({
    Nombre: investigator.nombre,
    Apellidos: investigator.apellidos,
    "Título (ES)": investigator.tituloEs,
    "Título (EN)": investigator.tituloEn,
    "Título (VA)": investigator.tituloVa,
    "Bio (ES)": investigator.bioEs,
    "Bio (EN)": investigator.bioEn,
    "Bio (VA)": investigator.bioVa,    
    Teléfono: investigator.telefono,
    Linkedin: investigator.linkedin,
    Facebook: investigator.facebook,
    Twitter: investigator.twitter,
    Doctorando: investigator.doctorando ? "Sí" : "No",
    "Grupo Funcional": investigator.grupoFuncional,
    "Es Investigador": investigator.esInvestigador ? "Sí" : "No",    
    Skype: investigator.skype,
    BlueSky: investigator.blueSky,
    Orcid: investigator.orcid,
    "Teléfono Personal": investigator.numeroTelefonoPersonal,   
    "Email Personal": investigator.email_personal,
    Sexo: investigator.sexo,
    "Dirección Postal Personal": investigator.direccionPostalPersonal,
    "Tipo Documento": investigator.tipoDocumento,
    "Documento de Identidad": investigator.documentoDeIdentidad,
    "Fecha de Nacimiento": investigator.fechaNacimiento,
    "Lugar de Nacimiento": investigator.lugarNacimiento,
    "Número Seguridad Social": investigator.numeroSeguroSocial,
    Rol: investigator.staffRole,
    Institución: investigator.institucion,  
    "Categoría Investigador Invitado":
      investigator.categoriaInvestigadorInvitado,
  }));

  const worksheet = XLSX.utils.json_to_sheet(dataToExport);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Investigadores");

  XLSX.writeFile(workbook, "investigadores.xlsx");
};


  return (
    <div className="container-fluid p-4">
      {/* {(userRoleId === 1 || userRoleId === 2) && ( */}
      <>
        {" "}
        <div className="row">
          <div className="col d-flex justify-content-between">
            <div>
              <h3>Usuarios</h3>
            </div>
            <div>
              <button
                className="baseBtn"
                onClick={() => history.push(`${ROUTES.Users.create}`)}
              >
                + Añadir
              </button>
              <button className="baseBtn ml-2" onClick={handleExportToExcel}>
                Descargar Excel
              </button>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          <Form.Group as={Col}>
            <InputGroup className="shadow">
              <InputGroup.Prepend>
                <InputGroup.Text className="inputGroup ">
                  <FontAwesomeIcon color="#0073B5" icon={faSearch} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control
                type="text"
                placeholder="Buscar..."
                className="form-control"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
            </InputGroup>
          </Form.Group>
        </div>
        <div className="row">
          <div className="col-12 ">
            <table className="table table-hover">
              <tbody>
                {filteredInvestigators?.map(
                  ({ id, nombre, apellidos }: IInvestShort) => (
                    <tr
                      key={id}
                      className="pointer"
                      onClick={() => history.push(`${ROUTES.Users.all}/${id}`)}
                    >
                      <td>{`${apellidos}, ${nombre}`}</td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
            {isLoading && (
              <div className="d-flex justify-content-center">
                <div className="spinner-border mt-5" role="status" />
              </div>
            )}

            {!filteredInvestigators.length && !isLoading && (
              <div className="d-flex justify-content-center mb-3">
                <h5>-No existen usuarios-</h5>
              </div>
            )}
          </div>
        </div>
      </>
      {/* )} */}
    </div>
  );
};
